module.exports = __webpack_public_path__ + "static/logo-branca-5d7614ec0d53ceb907df2a98ea796d82.svg";